import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-success-page',
  templateUrl: './success-page.component.html',
  styleUrls: ['./success-page.component.css']
})

export class SuccessPageComponent implements OnInit {
  busy: Subscription;
  constructor() { }

  ngOnInit(): void {
  }

}
